import script from "./SpamNumberPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpamNumberPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__